import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { ChecklistItemModel } from 'src/app/ViewModel/ChecklistItemModel';
import { IWorkflowStatusCLOutputModel, IWorkflowStatusViewModel } from 'src/app/ViewModel/WorkflowStatusModel';
import { RespondWorflowChecklistItemsComponent } from '../respond-worflow-checklist-items/respond-worflow-checklist-items.component';
import { NotificationService } from "src/app/Service/notification.service";


@Component({
  selector: 'app-workflow-status-checklist-dialog',
  templateUrl: './workflow-status-checklist-dialog.component.html',
  styleUrls: ['./workflow-status-checklist-dialog.component.css']
})
export class WorkflowStatusChecklistDialogComponent implements OnInit {
  selectedChecklistCollection!: any[];
  workflowCheckList: IWorkflowStatusCLOutputModel[] = [];
  getpopupValue: any;
  doc_No!: string;
  revision_No!:string;
  pageSize :number= 20;
 

  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public workflowTemplateService: WorkflowTemplateService,private _notificationService: NotificationService, public _dialogRef: MatDialogRef<WorkflowStatusChecklistDialogComponent>) { }

  ngOnInit() {
    this.doc_No = this.data.doc_No;
    this.revision_No = this.data.documentRevisionNo;
    this.openCL();
  }

  closeDialog() {
    this._dialogRef.close();
  }

  openCL() {
    this.workflowTemplateService.getWorkflowDocumentCheckist(this.data.doc_Id,this.data.documentRevisionNo,this.data.workflow_Id).subscribe((data) => {
      data.forEach((each:any) => {
        each['clFullName'] = each['clShortName'] + ' - ' + each['clName'];
      });
      this.selectedChecklistCollection = data;
    });
  }

  public openChecklistItems(dataItem: ChecklistItemModel) {
    
    let inputdata = dataItem;
    let dialogRef = this.dialog.open(RespondWorflowChecklistItemsComponent, {
      panelClass: 'mat-dialog-primary',
      data: { inputdata, isReadMode: true }
    });

    dialogRef.afterClosed().subscribe((data) => {
    });
  }

  
}

